import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { ArrowRight, Briefcase, Home as HomeIcon, Shield, IdCard, FileCheck, Globe } from "lucide-react";
import { getServices } from "@/api/services";
import { SEO } from "@/components/site/SEO";
const iconMap: Record<string, any> = { briefcase: Briefcase, home: HomeIcon, shield: Shield, "id-card": IdCard, "file-check": FileCheck, globe: Globe };

export function ServicesPage() {
  const { lang, t } = useLang();
  const [services, setServices] = useState<any[]>([]);
  useEffect(() => {
    getServices(true)
      .then(data => setServices(data ?? []))
      .catch(err => console.error('Failed to load services:', err));
  }, []);
  return (
    <div className="container mx-auto px-4 py-16">
      <SEO 
        title={t("section.services")} 
        description={
          lang === "tr" 
            ? "Awork Danışmanlık kurumsal hizmetleri: Yabancı çalışma izinleri, oturma izinleri, ikamet süreçleri ve danışmanlık hizmetlerimiz hakkında bilgi alın." 
            : "Get information about Awork Consulting services: Foreign work permits, residence permits, and our consulting services."
        }
      />
      <h1 className="text-4xl font-bold text-primary mb-2 text-center">{t("section.services")}</h1>
      <div className="w-20 h-1 bg-primary mx-auto mb-12 rounded-full" />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map(s => {
          const Icon = iconMap[s.icon] ?? Briefcase;
          const title = lang === "tr" ? s.title_tr : s.title_en;
          const short = lang === "tr" ? s.short_tr : s.short_en;
          return (
            <Link
              key={s.id}
              to={`/services/${s.slug}`}
              className="bg-card border overflow-hidden hover:shadow-xl transition-shadow group flex flex-col cursor-pointer"
            >
              <div className="h-70 bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center overflow-hidden">
                {s.image_url ? (
                  <img src={s.image_url} alt={title} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />
                ) : (
                  <Icon size={56} className="text-white/90" />
                )}
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-bold text-primary mb-2 min-h-[3rem]">{title}</h3>
                <p className="text-sm text-muted-foreground mb-4 flex-1">{short}</p>
                <div className="inline-flex items-center gap-1 text-primary font-medium text-sm group-hover:gap-2 transition-all">
                  {t("common.details")} <ArrowRight size={16} />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
